import { TreeTranslationsData } from '@tolgee/i18next';
import { I18nResource } from '@/i18n/i18n-supported-language';
import { I18nNamespace } from '@/i18n/i18nNamespaces';

export type TolgeeStaticDataKey = `${I18nResource}:${I18nNamespace}`;
export type TreeTranslationsDataImportFn = () => Promise<TreeTranslationsData>;
export type StrictTolgeeStaticData = Record<TolgeeStaticDataKey, TreeTranslationsDataImportFn>;

export const tolgeeStaticData: StrictTolgeeStaticData = {
  // th-TH
  'th-TH:activitySession': () => import('./resources/th-TH/activitySession.json'),
  'th-TH:activityReport': () => import('./resources/th-TH/activityReport.json'),
  'th-TH:avatar': () => import('./resources/th-TH/avatar.json'),
  'th-TH:classroom': () => import('./resources/th-TH/classroom.json'),
  'th-TH:common': () => import('./resources/th-TH/common.json'),
  'th-TH:gamification': () => import('./resources/th-TH/gamification.json'),
  'th-TH:leaderboard': () => import('./resources/th-TH/leaderboard.json'),
  'th-TH:lesson': () => import('./resources/th-TH/lesson.json'),
  'th-TH:lessonActivities': () => import('./resources/th-TH/lessonActivities.json'),
  'th-TH:lessonComplete': () => import('./resources/th-TH/lessonComplete.json'),
  'th-TH:lessonDetail': () => import('./resources/th-TH/lessonDetail.json'),
  'th-TH:lessonReport': () => import('./resources/th-TH/lessonReport.json'),
  'th-TH:lessonReportDetail': () => import('./resources/th-TH/lessonReportDetail.json'),
  'th-TH:login': () => import('./resources/th-TH/login.json'),
  'th-TH:network': () => import('./resources/th-TH/network.json'),
  'th-TH:portfolio': () => import('./resources/th-TH/portfolio.json'),
  'th-TH:schoolApp': () => import('./resources/th-TH/schoolApp.json'),
  'th-TH:signup': () => import('./resources/th-TH/signup.json'),
  'th-TH:splashScreen': () => import('./resources/th-TH/splashScreen.json'),
  'th-TH:userNotebook': () => import('./resources/th-TH/userNotebook.json'),
  'th-TH:userProfile': () => import('./resources/th-TH/userProfile.json'),
  'th-TH:liveSession': () => import('./resources/th-TH/liveSession.json'),
  // en-US
  'en-US:activitySession': () => import('./resources/en-US/activitySession.json'),
  'en-US:activityReport': () => import('./resources/en-US/activityReport.json'),
  'en-US:avatar': () => import('./resources/en-US/avatar.json'),
  'en-US:classroom': () => import('./resources/en-US/classroom.json'),
  'en-US:common': () => import('./resources/en-US/common.json'),
  'en-US:gamification': () => import('./resources/en-US/gamification.json'),
  'en-US:leaderboard': () => import('./resources/en-US/leaderboard.json'),
  'en-US:lesson': () => import('./resources/en-US/lesson.json'),
  'en-US:lessonActivities': () => import('./resources/en-US/lessonActivities.json'),
  'en-US:lessonComplete': () => import('./resources/en-US/lessonComplete.json'),
  'en-US:lessonDetail': () => import('./resources/en-US/lessonDetail.json'),
  'en-US:lessonReport': () => import('./resources/en-US/lessonReport.json'),
  'en-US:lessonReportDetail': () => import('./resources/en-US/lessonReportDetail.json'),
  'en-US:login': () => import('./resources/en-US/login.json'),
  'en-US:network': () => import('./resources/en-US/network.json'),
  'en-US:portfolio': () => import('./resources/en-US/portfolio.json'),
  'en-US:schoolApp': () => import('./resources/en-US/schoolApp.json'),
  'en-US:signup': () => import('./resources/en-US/signup.json'),
  'en-US:splashScreen': () => import('./resources/en-US/splashScreen.json'),
  'en-US:userNotebook': () => import('./resources/en-US/userNotebook.json'),
  'en-US:userProfile': () => import('./resources/en-US/userProfile.json'),
  'en-US:liveSession': () => import('./resources/en-US/liveSession.json'),
  // ja-JP
  'ja-JP:activitySession': () => import('./resources/ja-JP/activitySession.json'),
  'ja-JP:activityReport': () => import('./resources/ja-JP/activityReport.json'),
  'ja-JP:avatar': () => import('./resources/ja-JP/avatar.json'),
  'ja-JP:classroom': () => import('./resources/ja-JP/classroom.json'),
  'ja-JP:common': () => import('./resources/ja-JP/common.json'),
  'ja-JP:gamification': () => import('./resources/ja-JP/gamification.json'),
  'ja-JP:leaderboard': () => import('./resources/ja-JP/leaderboard.json'),
  'ja-JP:lesson': () => import('./resources/ja-JP/lesson.json'),
  'ja-JP:lessonActivities': () => import('./resources/ja-JP/lessonActivities.json'),
  'ja-JP:lessonComplete': () => import('./resources/ja-JP/lessonComplete.json'),
  'ja-JP:lessonDetail': () => import('./resources/ja-JP/lessonDetail.json'),
  'ja-JP:lessonReport': () => import('./resources/ja-JP/lessonReport.json'),
  'ja-JP:lessonReportDetail': () => import('./resources/ja-JP/lessonReportDetail.json'),
  'ja-JP:login': () => import('./resources/ja-JP/login.json'),
  'ja-JP:network': () => import('./resources/ja-JP/network.json'),
  'ja-JP:portfolio': () => import('./resources/ja-JP/portfolio.json'),
  'ja-JP:schoolApp': () => import('./resources/ja-JP/schoolApp.json'),
  'ja-JP:signup': () => import('./resources/ja-JP/signup.json'),
  'ja-JP:splashScreen': () => import('./resources/ja-JP/splashScreen.json'),
  'ja-JP:userNotebook': () => import('./resources/ja-JP/userNotebook.json'),
  'ja-JP:userProfile': () => import('./resources/ja-JP/userProfile.json'),
  'ja-JP:liveSession': () => import('./resources/ja-JP/liveSession.json'),
  // ko-KR
  'ko-KR:activitySession': () => import('./resources/ko-KR/activitySession.json'),
  'ko-KR:activityReport': () => import('./resources/ko-KR/activityReport.json'),
  'ko-KR:avatar': () => import('./resources/ko-KR/avatar.json'),
  'ko-KR:classroom': () => import('./resources/ko-KR/classroom.json'),
  'ko-KR:common': () => import('./resources/ko-KR/common.json'),
  'ko-KR:gamification': () => import('./resources/ko-KR/gamification.json'),
  'ko-KR:leaderboard': () => import('./resources/ko-KR/leaderboard.json'),
  'ko-KR:lesson': () => import('./resources/ko-KR/lesson.json'),
  'ko-KR:lessonActivities': () => import('./resources/ko-KR/lessonActivities.json'),
  'ko-KR:lessonComplete': () => import('./resources/ko-KR/lessonComplete.json'),
  'ko-KR:lessonDetail': () => import('./resources/ko-KR/lessonDetail.json'),
  'ko-KR:lessonReport': () => import('./resources/ko-KR/lessonReport.json'),
  'ko-KR:lessonReportDetail': () => import('./resources/ko-KR/lessonReportDetail.json'),
  'ko-KR:login': () => import('./resources/ko-KR/login.json'),
  'ko-KR:network': () => import('./resources/ko-KR/network.json'),
  'ko-KR:portfolio': () => import('./resources/ko-KR/portfolio.json'),
  'ko-KR:schoolApp': () => import('./resources/ko-KR/schoolApp.json'),
  'ko-KR:signup': () => import('./resources/ko-KR/signup.json'),
  'ko-KR:splashScreen': () => import('./resources/ko-KR/splashScreen.json'),
  'ko-KR:userNotebook': () => import('./resources/ko-KR/userNotebook.json'),
  'ko-KR:userProfile': () => import('./resources/ko-KR/userProfile.json'),
  'ko-KR:liveSession': () => import('./resources/ko-KR/liveSession.json'),
  // tr-TR
  'tr-TR:activitySession': () => import('./resources/tr-TR/activitySession.json'),
  'tr-TR:activityReport': () => import('./resources/tr-TR/activityReport.json'),
  'tr-TR:avatar': () => import('./resources/tr-TR/avatar.json'),
  'tr-TR:classroom': () => import('./resources/tr-TR/classroom.json'),
  'tr-TR:common': () => import('./resources/tr-TR/common.json'),
  'tr-TR:gamification': () => import('./resources/tr-TR/gamification.json'),
  'tr-TR:leaderboard': () => import('./resources/tr-TR/leaderboard.json'),
  'tr-TR:lesson': () => import('./resources/tr-TR/lesson.json'),
  'tr-TR:lessonActivities': () => import('./resources/tr-TR/lessonActivities.json'),
  'tr-TR:lessonComplete': () => import('./resources/tr-TR/lessonComplete.json'),
  'tr-TR:lessonDetail': () => import('./resources/tr-TR/lessonDetail.json'),
  'tr-TR:lessonReport': () => import('./resources/tr-TR/lessonReport.json'),
  'tr-TR:lessonReportDetail': () => import('./resources/tr-TR/lessonReportDetail.json'),
  'tr-TR:login': () => import('./resources/tr-TR/login.json'),
  'tr-TR:network': () => import('./resources/tr-TR/network.json'),
  'tr-TR:portfolio': () => import('./resources/tr-TR/portfolio.json'),
  'tr-TR:schoolApp': () => import('./resources/tr-TR/schoolApp.json'),
  'tr-TR:signup': () => import('./resources/tr-TR/signup.json'),
  'tr-TR:splashScreen': () => import('./resources/tr-TR/splashScreen.json'),
  'tr-TR:userNotebook': () => import('./resources/tr-TR/userNotebook.json'),
  'tr-TR:userProfile': () => import('./resources/tr-TR/userProfile.json'),
  'tr-TR:liveSession': () => import('./resources/tr-TR/liveSession.json'),
  // hi-IN
  'hi-IN:activitySession': () => import('./resources/hi-IN/activitySession.json'),
  'hi-IN:activityReport': () => import('./resources/hi-IN/activityReport.json'),
  'hi-IN:avatar': () => import('./resources/hi-IN/avatar.json'),
  'hi-IN:classroom': () => import('./resources/hi-IN/classroom.json'),
  'hi-IN:common': () => import('./resources/hi-IN/common.json'),
  'hi-IN:gamification': () => import('./resources/hi-IN/gamification.json'),
  'hi-IN:leaderboard': () => import('./resources/hi-IN/leaderboard.json'),
  'hi-IN:lesson': () => import('./resources/hi-IN/lesson.json'),
  'hi-IN:lessonActivities': () => import('./resources/hi-IN/lessonActivities.json'),
  'hi-IN:lessonComplete': () => import('./resources/hi-IN/lessonComplete.json'),
  'hi-IN:lessonDetail': () => import('./resources/hi-IN/lessonDetail.json'),
  'hi-IN:lessonReport': () => import('./resources/hi-IN/lessonReport.json'),
  'hi-IN:lessonReportDetail': () => import('./resources/hi-IN/lessonReportDetail.json'),
  'hi-IN:login': () => import('./resources/hi-IN/login.json'),
  'hi-IN:network': () => import('./resources/hi-IN/network.json'),
  'hi-IN:portfolio': () => import('./resources/hi-IN/portfolio.json'),
  'hi-IN:schoolApp': () => import('./resources/hi-IN/schoolApp.json'),
  'hi-IN:signup': () => import('./resources/hi-IN/signup.json'),
  'hi-IN:splashScreen': () => import('./resources/hi-IN/splashScreen.json'),
  'hi-IN:userNotebook': () => import('./resources/hi-IN/userNotebook.json'),
  'hi-IN:userProfile': () => import('./resources/hi-IN/userProfile.json'),
  'hi-IN:liveSession': () => import('./resources/hi-IN/liveSession.json'),
};
